import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { DOCUMENT, LocationStrategy, ViewportScroller } from '@angular/common';
import { Chart, ChartOptions, scales } from 'chart.js';
import {
  SharedFacade,
  customDecode,
  customEncode,
  delayedFunctionCall,
  getRandomColorWithOpacity,
  yAxisformateValue,
  addFullStop,
  wrapLabel,
  EolNavigationService,
} from '@piqet-angular/data';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { bottom } from '@popperjs/core';
import { ToastrService } from 'ngx-toastr';
import tippy, { followCursor } from 'tippy.js';
import {
  commonEnum,
  FeatureCodes,
  ImpactCategoriesEnum,
  materialCircularityIndex,
  PEF_NORMALIZED,
  PEF_WEIGHTED,
  ReportTypeEnum,
} from 'libs/shared/src/lib/constants';
import { callback } from 'chart.js/dist/helpers/helpers.core';
import {
  isFeatureEnabled,
  showFeatureAlert,
  validateFeatures,
  FeatureValidation,
} from '../../../../../../../shared/src/lib/service/helper.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { JoyrideService } from 'ngx-joyride';

@Component({
  selector: 'piqet-angular-project-report-chart-glance',
  templateUrl: './project-report-chart-glance.component.html',
  styleUrls: ['./project-report-chart-glance.component.scss'],
})
export class ProjectReportChartGlanceComponent {
  FeatureCodes = FeatureCodes;
  CHART_COMPARE_DESCRIPTION_TO_FEATURE: Record<string, FeatureCodes> = {
    'Life cycle stage': FeatureCodes.REPORTS_LIFE_CYCLE_STAGE,
    'Packaging Level': FeatureCodes.REPORTS_PACKAGING_LEVEL,
    'Packaging components': FeatureCodes.REPORTS_PACKAGING_COMPONENTS,
    'Product loss': FeatureCodes.REPORTS_PRODUCT_LOSS,
    Ingredients: FeatureCodes.REPORTS_INGREDIENTS,
    Transport: FeatureCodes.REPORTS_TRANSPORT,
    'PEF categories (with toxicity)': FeatureCodes.REPORTS_PEF_CATEGORIES_WITH_TOXICITY,
    'PEF categories (without toxicity)': FeatureCodes.REPORTS_PEF_CATEGORIES_WITHOUT_TOXICITY,
  };
  background: any; //FOR BG color in bar chart
  @Input() headerBtn: any;
  chartOpacity: any = { value: commonEnum.opacity };
  opacity: any = 0.5;
  ReportTypeEnum = ReportTypeEnum;
  reportTypeId: any;
  getchartImpactCategoryIdData: any;
  data: any;
  isBarChartSelected = true;
  isTypeSelected: any;
  isEquivalentFunctionUnitSelected = false;
  percentArrayOne: any = [];
  parentArr: any = [];
  componentItemsArray: any = [];
  kendoData: any = [];
  segmentColors: any = [];
  segments: any = [];
  categories: any;
  isWeightSelected = false;
  pefWeighted: any;
  pefNonWeighted: any;
  topIndicatorName!: string;
  isCustomInclude = false;
  generatedInterpretation = false;
  setChartTypeId = commonEnum.barChartOption;
  selectedIndicator: any;
  reportChartForm!: FormGroup;
  interpretationForm!: FormGroup;
  inValidScenarios = [];
  showIncorrectEOLNotification = false;
  incorrectValueMessage =
    'Report results may be inaccurate due to outdated EOL rates in the project. Please update them before generating results.';
  incorrectBtnName = 'Show scenarios';
  countryList = [
    { name: 'Image' },
    { name: 'Packaging level' },
    { name: 'Quantity in packaging level' },
    { name: 'Packaging level detail' },
    { name: 'Total units per traded unit' },
    { name: 'Actions' },
  ];
  generatedChartType = 'column';
  isChartNormalized = false;
  isCheckInterpretationDisabled = false;
  departmentValue = [{ name: 'Image' }, { name: 'Image1' }, { name: 'Image2' }];
  spiderChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxHeight: 8,
          boxWidth: 8,
          color: 'black', // Font color for legend labels
          font: {
            size: 14,
            family: 'Neue Montreal',
          },
          padding: 90, // Padding between legend labels and other elements
          generateLabels: (chart: any) => {
            // Add space between legend marker and text (adjust the pixel value as needed)
            const original = Chart.defaults.plugins.legend.labels.generateLabels(chart);
            const chartValue = getRandomColorWithOpacity(1);
            original.forEach((label: any, index: any) => {
              label.text = '   ' + label.text;
              label.fillStyle = chartValue[index].rgba;
            });
            return original;
          },
        },
      },
    },
    scales: {
      // y: {
      //   beginAtZero: true
      // },
      r: {
        beginAtZero: true,
        min: 0,
        alignToPixels: true,
        pointLabels: {
          display: false, // Hide point labels
        },
        ticks: {
          display: true, // Hide tick marks
          count: 3,
          padding: 40,
        },
      },
    },
    layout: {
      padding: {
        top: 90,
        left: 0,
        bottom: 20, // Adjust bottom padding to provide space below the legend
        right: 0,
      },
    },
  };
  imageCache: Map<string, HTMLImageElement> = new Map<string, HTMLImageElement>();
  doughnutChartPlugins = [
    {
      id: 'custom_labels',
      afterDraw: async (chart: any, args: any) => {
        const loadImage = (src: string) => {
          return new Promise<HTMLImageElement>((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = reject;
            image.src = src;
          });
        };

        try {
          const imagePromises: Promise<HTMLImageElement>[] = [];
          this.chartImage?.forEach((imageSrc: any) => {
            if (this.imageCache.has(imageSrc)) {
              imagePromises.push(Promise.resolve(this.imageCache.get(imageSrc)!));
            } else {
              const promise = loadImage(imageSrc).then(image => {
                this.imageCache.set(imageSrc, image);
                return image;
              });
              imagePromises.push(promise);
            }
          });

          const images = await Promise.all(imagePromises);
          const scale = chart.scales['r'];
          for (let i = 0; i < images.length; i++) {
            await this.drawTextAtIndex(images[i], scale, i, this.spiderChartLabels[i], i);
          }
        } catch (error) {
          console.error('Error loading image:', error);
        }
      },
    },
  ];
  mbarChartLabels: string[] = [];

  barChartOptions: ChartOptions | any = {
    scaleShowVerticalLines: false,
    indexAxis: null,
    responsive: true,
    scales: {
      x: {
        ticks: {
          font: {
            size: 14, // Adjust the font size as needed
          },
          padding: 10,
        },
      },
      y: {
        ticks: {
          font: {
            size: 14, // Adjust the font size as needed
          },
        },
        beginAtZero: true,
        title: {
          display: true, // Set your Y-axis label here
          text: '',
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            // Generated to access once chart is created. DO NOT REMOVE
          },
        },
      },
      legend: {
        display: true,
        position: bottom,
        labels: {
          usePointStyle: true,
          boxHeight: 6,
          boxWidth: 6,
          color: 'black', // Font color for legend labels
          font: {
            size: 14,
            family: 'Neue Montreal',
          }, // Font size for legend labels
          padding: 20, // Padding between legend labels and other elements
          generateLabels: (chart: any) => {
            // Add space between legend marker and text (adjust the pixel value as needed)
            const original = Chart.defaults.plugins.legend.labels.generateLabels(chart);
            const chartValue = getRandomColorWithOpacity(1);
            original.reverse().forEach((label: any, index: any) => {
              label.text = '   ' + label.text;
              label.fillStyle = chartValue[index].rgba;
            });
            return original;
          },
        },
      },
    },
  };
  spiderChartLabels: string[] = [];
  spiderChartData: any = [];
  barChartData: any = [];
  generated = false;
  selectedScenarios: any;
  materialCircularityIndex = materialCircularityIndex;
  selectedCatogories: any;
  functionalUnitId: any;
  chartTypeId: any;
  indicatorId: any;
  componentItems: any;
  materialArr: any = [];
  conversionArr: any = [];
  ingredientArr: any = [];
  manufacturingArr: any = [];
  fillArr: any = [];
  wholesaleArr: any = [];
  retialArr: any = [];
  consumerArr: any = [];
  eolArr: any = [];
  totalArr: any = [];
  impactCatogaryId: any;
  chartImage: any;
  baseScenarioId: any;
  chartTypeItemsData: any;
  packagingComponentItems: any = [];
  packagingComponent1: any;
  packagingComponent2: any;
  packagingComponent3: any;
  packagingComponentName1: any;
  packagingComponentName2: any;
  packagingComponentName3: any;
  pointers: any = [
    {
      value: 0,
      color: '#9747ff',
      length: 1,
    },
  ];
  pointers1: any = [
    {
      value: 0,
      color: '#9747ff',
      length: 1,
    },
  ];
  pointers2: any = [
    {
      value: 0,
      color: '#9747ff',
      length: 1,
    },
  ];
  pointersArray: any = [];
  gaugeLegends: any = [];
  flagName: any;
  chartTypeItems: any;
  chartImpactCategoryItems: any;
  chartCompareItems: any;
  productPackageScenarioItems: any;
  functionalUnitItems: any;
  indicatorItems: any;
  borderColor: any;
  indicatorsName: any;
  interpretation: any;
  selectComparisionData: any;
  selectCategoryIncludeData: any;
  activatedRouteProjectId: any;
  pointer1Max = 100;
  pointer2Max = 100;
  pointer3Max = 100;
  speedosImpactCategoryItems: any = [];
  pef_weighted: any;
  pef_normalized: any;
  selectedPEFType = 'Normalized';
  isPEFResults = false;
  incorrectFillingValueMessage = 'Action needed: Please update the filling country.';
  incorrectFillingBtnName = 'Go to filling';
  incorrectFilling: any = [];
  showIncorrectFillingNotification = false;
  PEF_WITH_TOXICITY = 'PEF categories (with toxicity)';
  PEF_WITHOUT_TOXICITY = 'PEF categories (without toxicity)';

  constructor(
    private renderer: Renderer2,
    private projectService: ProjectsService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private sharedFacade: SharedFacade,
    private reportService: ReportsService,
    private eolNavService: EolNavigationService,
    private sharedService: SharedService,
    public route: ActivatedRoute,
    private toaster: ToastrService,
    private eel: ElementRef,
    private viewportScroller: ViewportScroller,
    private swalService: SwalService,
    private joyrideService: JoyrideService,
    private locationStrategy: LocationStrategy
  ) {
    this.sharedService.scenarioNameFunc('Chart at a glance');
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.3/Chart.min.js';
    this.renderer.appendChild(document.body, script);
    this.route.queryParams.subscribe((data: any) => {
      this.flagName = Boolean(data['flagName']);
    });
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
  }

  async ngOnInit() {
    !this.joyrideService.isTourInProgress() && this.viewportScroller.scrollToPosition([0, 0]);
    this.isCheckInterpretationDisabled = !isFeatureEnabled(
      FeatureCodes.REPORTS_INTERPRETATION_SECTION
    );

    await this.initFormValue();
    await this.getGlanceData();
    await this.setIndicatorItem();
    await this.getChartTypeData();
    await this.getchartImpactCategoryId();
    //BAR CHART
    this.setFormValue();
  }

  triggerScroll(): void {
    this.sharedService.triggerScroll();
  }

  async getGlanceData() {
    const response = await this.projectService.getChartAtAGlanceData(
      Number(atob(decodeURIComponent(customDecode(location.href.split('/')[6]))))
    );
    this.data = response.data;
    this.productPackageScenarioItems = this.data.productPackageScenarioItems;
    if (this.data?.scenarioIds?.split(',')?.length > 0) {
      const res = await this.reportService.GetChartTypeOptionsProjectReport(
        this.data?.scenarioIds?.split(',').length
      );
      const mapRes = res.data.map((x: any) => {
        return {
          ...x,
          description: x.name,
        };
      });
      this.chartTypeItems = mapRes;
    }
    this.chartCompareItems = this.data.chartCompareItems;
    this.chartCompareItems = this.data.chartCompareItems.map((item: any) => {
      const featureCode = this.CHART_COMPARE_DESCRIPTION_TO_FEATURE[item.description];
      const isEnabled = featureCode ? isFeatureEnabled(featureCode) : true;

      return {
        ...item,
        disabled: !isEnabled,
      };
    });
    this.chartImpactCategoryItems = this.data.chartImpactCategoryItems;
    this.functionalUnitItems = this.data.functionalUnitItems;
    this.showIncorrectEOLNotification = response.data?.invalidEOLRates;
    this.inValidScenarios = response.data?.inValidScenarios;
    this.incorrectBtnName = this.inValidScenarios.length > 1 ? 'Show scenarios' : 'Go to scenario';
    this.indicatorItems = this.data.indicatorItems;
    this.showIncorrectFillingNotification = this.data?.incorrectFillingDataList?.length > 0;
    this.incorrectFilling = this.data?.incorrectFillingDataList || [];
    this.incorrectFillingBtnName =
      this.incorrectFilling.length > 1 ? 'Show scenarios' : 'Go to filling';
    this.interpretation = this.data.interpretation;
    this.chartTypeId = this.data.chartTypeId;
    this.indicatorId = this.data.indicatorId;
    const filteredData = this.productPackageScenarioItems.filter((item: any) =>
      this.data?.scenarioIds?.includes(item.idStr)
    );
    this.selectedScenarios = filteredData;
  }

  async setIndicatorItem() {
    await this.data.indicatorItems.map((item: any) => {
      if (item.id == this.data.indicatorId) {
        return (this.selectedIndicator = item);
      }
    });
  }
  async getChartTypeData() {
    await this.data.chartTypeItems.map((item: any) => {
      if (item.id == this.data.chartTypeId) {
        this.isBarChartSelected = item.id === 2 ? true : false;
        return (this.chartTypeItemsData = item);
      }
    });
  }
  async getchartImpactCategoryId() {
    await this.data.chartImpactCategoryItems.map((item: any) => {
      if (item.id == this.data.chartImpactCategoryId) {
        this.isCustomInclude = item.name == 'Customize categories' ? true : false;
        this.impactCatogaryId = item.id;
        if (item.name == 'Customize categories') {
          this.reportChartForm.controls['categoryInclude'].setValidators([Validators.required]);
        } else {
          this.reportChartForm.controls['categoryInclude'].clearValidators();
        }
        this.reportChartForm.controls['categoryInclude'].updateValueAndValidity();
        return (this.getchartImpactCategoryIdData = item);
      }
    });
  }

  baselineValue(event: any) {
    if (!event.idStr) return;
    this.baseScenarioId = event.idStr;
  }

  async initFormValue() {
    this.reportChartForm = this.formBuilder.group({
      scenarios: [null, Validators.required],
      chartType: [null, Validators.required],
      impactCategory: [null],
      comparision: [null],
      categoryInclude: [null],
      functionalUnit: [null, Validators.required],
      baselineFunctional: [null],
    });
    this.interpretationForm = this.formBuilder.group({
      interpretation: ['', Validators.required],
    });
  }
  getMatchingScenarioIds(dataArray: any, fullReportScenarioIds: any) {
    const matchingIds: any = [];
    dataArray.forEach((item: any) => {
      if (fullReportScenarioIds?.includes(item.idStr)) {
        matchingIds.push(item.idStr);
      }
    });
    return matchingIds;
  }
  setFormValue() {
    const indicatorsArray = this.data?.chartIndicators?.split(',')?.map(Number);
    const filteredRecords = this.indicatorItems?.filter((record: any) =>
      indicatorsArray?.includes(record.id)
    );
    const scenarioBindIds = this.getMatchingScenarioIds(
      this.productPackageScenarioItems,
      this.data?.scenarioIds?.split(',')
    );
    this.reportChartForm.patchValue({
      chartType: this.chartTypeItemsData || (this.chartTypeItems ? this.chartTypeItems[0] : null),
      impactCategory: this.getchartImpactCategoryIdData,
      comparision: this.data?.chartCompareItems[0],
      scenarios: scenarioBindIds,
      functionalUnit: this.functionalUnitItems[0],
    });
    !this.isBarChartSelected && this.isCustomInclude
      ? this.reportChartForm.patchValue({ categoryInclude: filteredRecords })
      : this.reportChartForm.patchValue({
          categoryInclude: this.selectedIndicator || this.indicatorItems[0],
        });
    this.interpretationForm.patchValue({ interpretation: this.interpretation });
    this.isTypeSelected = this.chartTypeItemsData ? true : false;
  }

  compareFn(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  chartType(event: any) {
    if (event?.id) {
      this.isBarChartSelected = event.id === 2 ? true : false;
      this.isTypeSelected = true;
      if (this.isBarChartSelected) {
        this.reportChartForm.patchValue({
          categoryInclude: this.selectCategoryIncludeData
            ? this.selectCategoryIncludeData
            : this.selectedIndicator,
          impactCategory: this.selectCategoryIncludeData,
          comparision: this.selectComparisionData
            ? this.selectComparisionData
            : this.data?.chartCompareItems[0],
        });
        this.reportChartForm.controls['comparision'].setValidators([Validators.required]);
        this.reportChartForm.controls['impactCategory'].clearValidators();
      } else {
        this.reportChartForm.controls['impactCategory'].reset();
        this.reportChartForm.patchValue({ impactCategory: this.getchartImpactCategoryIdData });
        this.reportChartForm.controls['impactCategory'].setValidators([Validators.required]);
        this.reportChartForm.controls['categoryInclude'].setValue(null);
        this.reportChartForm.controls['comparision'].clearValidators();
      }
      this.reportChartForm.controls['comparision'].updateValueAndValidity();
      this.reportChartForm.controls['impactCategory'].updateValueAndValidity();
      this.chartTypeId = event.id;
    }
  }

  functionalUnit(event: any) {
    if (!event.id) return;
    this.isEquivalentFunctionUnitSelected = event.id === 3 ? true : false;
    if (this.isEquivalentFunctionUnitSelected) {
      this.reportChartForm.controls['baselineFunctional'].setValidators([Validators.required]);
    } else {
      this.reportChartForm.controls['baselineFunctional'].clearValidators();
    }
    this.reportChartForm.controls['baselineFunctional'].updateValueAndValidity();
    this.functionalUnitId = event.id;
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchDis(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }
  async scenarioSelected(event: any) {
    this.reportChartForm.controls['baselineFunctional'].setValue(null);
    if (!event.length) {
      this.selectedScenarios = null;
      return;
    }
    this.selectedScenarios = event;
    const res = await this.reportService.GetChartTypeOptionsProjectReport(
      this.selectedScenarios.length
    );
    const mapRes = res.data.map((x: any) => {
      return {
        ...x,
        description: x.name,
      };
    });
    this.chartTypeItems = mapRes;
    if (this.selectedScenarios.length == 1 && this.isTypeSelected) {
      this.reportChartForm.patchValue({ chartType: this.chartTypeItems[0] });
      this.reportChartForm.controls['categoryInclude'].setValue(null);
      this.isBarChartSelected = true;
      this.chartTypeId = 2;
    }
  }

  selectedCategory(event: any) {
    if (!event.id) return;
    this.indicatorId = event.id;
    this.selectCategoryIncludeData = event;
  }

  catogorySelected(event: any) {
    if (!event.length) return;
    this.selectedCatogories = event;
  }

  getImpactCatogaryId(data: any) {
    if (data.id) {
      this.isPEFResults = false;
      this.getchartImpactCategoryIdData = data;
      this.isCustomInclude = data.name == 'Customize categories' ? true : false;
      if (data.name == 'Customize categories') {
        this.reportChartForm.controls['categoryInclude'].setValidators([Validators.required]);
      } else {
        this.reportChartForm.controls['categoryInclude'].clearValidators();
      }
      this.reportChartForm.controls['categoryInclude'].updateValueAndValidity();
      this.impactCatogaryId = data.id;
    }
  }
  getChartCompareId(event: any) {
    this.isChartNormalized = false;
    this.generatedChartType = 'column';
    this.selectComparisionData = event;
    switch (event.id) {
      case 1:
        this.reportTypeId = ReportTypeEnum.CustomContributionAnalysisHighLevel;
        break;
      case 2:
        this.reportTypeId = ReportTypeEnum.ContributionbyPackagingLevel;
        break;
      case 3:
        this.reportTypeId = ReportTypeEnum.ContributionbyComponent;
        break;
      case 4:
        this.reportTypeId = ReportTypeEnum.ContributionbyProductLosses;
        break;
      case 5:
        this.reportTypeId = ReportTypeEnum.ContributionbyIngredient;
        break;
      case 6:
        this.reportTypeId = ReportTypeEnum.ContributionofTransport;
        break;
      case 7:
        this.reportTypeId = ReportTypeEnum.PEF_Categories_tox;
        this.impactCatogaryId = ImpactCategoriesEnum.PEFCategoriesWithTOX;
        this.updateValidationForPEFCategories();
        break;
      case 8:
        this.reportTypeId = ReportTypeEnum.PEF_Categories_without_tox;
        this.impactCatogaryId = ImpactCategoriesEnum.PEFCategoriesWithoutTOX;
        this.updateValidationForPEFCategories();
        break;
      default:
        break;
    }
  }

  updateValidationForPEFCategories() {
    this.reportChartForm.controls['categoryInclude'].clearValidators();
    this.reportChartForm.controls['categoryInclude'].updateValueAndValidity();
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }

  async drawTextAtIndex(
    image: HTMLImageElement,
    scale: any,
    index: number,
    text: string,
    counter: number
  ) {
    const offset = 55;
    const r = scale.drawingArea + offset;
    const angle = scale.getIndexAngle(index) - Math.PI / 2;
    const x = scale.xCenter + Math.cos(angle) * r;
    const y = scale.yCenter + Math.sin(angle) * r;
    const ctx = scale.ctx;
    ctx.save();
    ctx.translate(x, y);
    ctx.textAlign = 'center';
    ctx.font = '12px Neue Montreal, Arial, sans-serif';
    const lineHeight = 12; // Adjust this value as needed
    const lines = [];
    const words = text.split(' ');
    let currentLine = words[0];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const testLine = currentLine + ' ' + word;
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      const maxWidth = 100;

      if (testWidth <= maxWidth) {
        currentLine = testLine;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }

    lines.push(currentLine);

    // Calculate vertical position for centered text
    const textHeight = lines.length * lineHeight + 10;
    const startY = -(textHeight / 2) + lineHeight / 2 + 11; // Position the text normally

    if (this.spiderChartLabels.length < 15) {
      ctx.drawImage(image, -13, -(textHeight / 2) - 23, 29, 29); // Position the image above the text
    }

    ctx.fillStyle = 'black';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      ctx.fillText(line, 0, startY + i * lineHeight);
    }

    ctx.restore();
  }

  private validateReportFeatures(): string[] {
    const formValues = this.reportChartForm.value;
    const validations: FeatureValidation[] = [];

    // Check if selected comparison requires specific features
    if (this.isBarChartSelected && formValues.comparision) {
      const comparisonName = formValues.comparision.description;
      const featureCode = this.CHART_COMPARE_DESCRIPTION_TO_FEATURE[comparisonName];

      if (featureCode && !isFeatureEnabled(featureCode)) {
        validations.push({
          condition: true,
          featureCode: featureCode,
          featureName: comparisonName,
        });
      }
    }

    // Additional validation for PEF categories if needed
    if (this.reportTypeId === ReportTypeEnum.PEF_Categories_tox) {
      validations.push({
        condition: true,
        featureCode: FeatureCodes.REPORTS_PEF_CATEGORIES_WITH_TOXICITY,
        featureName: 'PEF categories (with toxicity)',
      });
    }

    if (this.reportTypeId === ReportTypeEnum.PEF_Categories_without_tox) {
      validations.push({
        condition: true,
        featureCode: FeatureCodes.REPORTS_PEF_CATEGORIES_WITHOUT_TOXICITY,
        featureName: 'PEF categories (without toxicity)',
      });
    }

    return validateFeatures(validations, isFeatureEnabled);
  }

  onGenerate() {
    this.generated = true;
    if (this.reportChartForm.invalid) {
      return;
    }
    const missingFeatures = this.validateReportFeatures();

    if (missingFeatures.length > 0) {
      showFeatureAlert(missingFeatures, this.swalService);
      return;
    }
    this.componentItemsArray = [];
    this.packagingComponentItems = [];
    this.speedosImpactCategoryItems = [];
    this.sharedService.show('');
    const scenarioIds = this.selectedScenarios?.map((x: any) => {
      return x.idStr;
    });
    const IndicatorIdds = this.selectedCatogories?.map((x: any) => {
      return x.id;
    });
    const projectId = Number(atob(decodeURIComponent(customDecode(location.href.split('/')[6]))));
    this.setChartTypeId = this.chartTypeId || 2;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (
      this.chartTypeId == 3 ||
      (this.isBarChartSelected &&
        (this.reportTypeId == ReportTypeEnum.PEF_Categories_tox ||
          this.reportTypeId == ReportTypeEnum.PEF_Categories_without_tox))
    ) {
      // FOR SPIDER CHART
      const payload = {
        scenarioIds: scenarioIds?.toString() || this.data?.scenarioIds,
        IndicatorIddStr: IndicatorIdds?.toString() || this.data?.chartIndicators,
        reportFormatId: 2,
        reportTypeId: this.reportTypeId || 14,
        baseScenarioId: this.reportChartForm.controls['baselineFunctional'].value?.idStr
          ? this.reportChartForm.controls['baselineFunctional'].value.idStr
          : 0,
        chartImpactCategoryId: this.impactCatogaryId,
        imapctCategoryId: this.impactCatogaryId,
        indicatorIds: this.indicatorId,
        impactTypeIds: '',
        charttypeId: this.chartTypeId || 2,
        functionalUnitId: this.functionalUnitId || 1,
        projectId: Number(projectId),
        isExport: false,
        isExportPdf: false,
        indicatorIdd: this.indicatorId,
        isExcludeProductImpacts: false,
        IndicatorId: '',
        isPEFCategoriesResult:
          this.isBarChartSelected &&
          (this.reportTypeId == ReportTypeEnum.PEF_Categories_tox ||
            this.reportTypeId == ReportTypeEnum.PEF_Categories_without_tox),
      };
      this.projectService.generateSpiderChart(payload).subscribe((res: any) => {
        this.barChartData = [];
        if (res) {
          this.isPEFResults = false;
          const response = res.data;
          this.opacity = response.opacity;
          this.chartOpacity = { value: this.opacity };
          this.speedosImpactCategoryItems = response?.speedosImpactCategoryItems ?? [];
          this.generateIndicators(response.packagingComponentItems, response.scenarioList);
          this.generated = true;
          if (
            this.isBarChartSelected &&
            (this.reportTypeId == ReportTypeEnum.PEF_Categories_tox ||
              this.reportTypeId == ReportTypeEnum.PEF_Categories_without_tox)
          ) {
            this.indicatorsName = 'Fraction of global impact per person';
            this.pef_weighted = response?.pef_weighted;
            this.pef_normalized = response?.pef_normalized;
            this.isPEFResults = true;
            this.changePEFCategories('Normalized');
          } else {
            this.componentItemsArray = response.scenarioList;
            const holdingArr: any = [];
            if (response?.scenarioList?.length > 0) {
              this.componentItems = this.splitterFunc(response.scenarioList[0].indicators);
            }
            for (let i = 0; i < this.componentItems.length; i++) {
              holdingArr.push([]);
            }
            this.parentArr = holdingArr;
            this.spiderChartLabels = this.componentItems;
            const chartData = this.GetSpiderChart();
            this.spiderChartData = chartData;
          }
        }
      });
    } else {
      // FOR BARCHART
      const payload = {
        scenarioIds: scenarioIds?.toString() || this.data?.scenarioIds,
        reportFormatId: 2,
        reportTypeId: this.reportTypeId || 14,
        baseScenarioId: this.baseScenarioId || '',
        chartImpactCategoryId: 7,
        imapctCategoryId: '',
        indicatorIds: this.indicatorId || 1,
        impactTypeIds: '',
        charttypeId: this.chartTypeId || 2,
        functionalUnitId: this.functionalUnitId || 1,
        projectId: Number(projectId),
        isExport: false,
        isExportPdf: false,
        indicatorIdd: this.indicatorId || 1,
        isExcludeProductImpacts: false,
        IndicatorId: this.indicatorId || 1,
      };
      this.projectService.generateBarChart(payload).subscribe((res: any) => {
        if (res) {
          const response = res.data;
          this.isPEFResults = false;
          this.indicatorsName = response.indicatorName;
          this.generatedChartType = 'column';
          this.componentItemsArray = response?.componentItems;
          this.generated = true;
          this.opacity = response.opacity;
          this.chartOpacity = { value: this.opacity };
          this.speedosImpactCategoryItems = response?.speedosImpactCategoryItems ?? [];
          this.generateIndicators(response.packagingComponentItems, response.scenarioData);
          this.getTopIndicatorName(response.reportTypeId);
          const holdingArr: any = [];
          if (response?.componentItems?.length > 0) {
            this.componentItems = this.splitterFunc(response?.componentItems[0].componentName);
          }
          for (let i = 0; i < this.componentItems.length; i++) {
            holdingArr.push([]);
          }
          this.parentArr = holdingArr;
          this.mbarChartLabels = this.componentItems;
          this.categories = this.componentItems;
          this.barChartData = this.convertToMultiArr().reverse();
          this.sharedService.show('');
        }
      });
      // FOR CUSTOMISING LABEL in BAR CHART
      this.barChartOptions.plugins.tooltip.callbacks.label = (context: any) => {
        if (context.dataset.percent) {
          return [`${context.dataset.label}: ` + context.dataset.percent[context.dataIndex] + `%`];
        }
      };
    }
  }

  changePEFCategories(type: string) {
    this.selectedPEFType = type;
    if (type === 'Weighted') {
      this.componentItemsArray = this.pef_weighted;
      this.topIndicatorName = PEF_WEIGHTED;
      this.generatedChartType = 'bar';
      this.isChartNormalized = false;
      this.chartOpacity = { value: this.opacity };
    } else {
      this.componentItemsArray = this.pef_normalized;
      this.topIndicatorName = PEF_NORMALIZED;
      this.generatedChartType = 'column';
      this.isChartNormalized = true;
      this.chartOpacity = { value: this.opacity };
    }
  }

  barChartGenerate(response: any, generateVertical?: boolean) {
    this.componentItemsArray = response;
    const holdingArr: any = [];
    if (this.componentItemsArray.length > 0) {
      this.componentItems = this.splitterFunc(this.componentItemsArray[0].componentName);
    }
    for (let i = 0; i < this.componentItems.length; i++) {
      holdingArr.push([]);
    }
    this.parentArr = holdingArr;
    this.mbarChartLabels = this.componentItems;
    this.categories = this.componentItems;
    this.barChartData = generateVertical
      ? this.convertToMultiArr(generateVertical).reverse()
      : this.convertToMultiArr().reverse();
    if (generateVertical) this.topIndicatorName = 'Contribution by PEF categories';
  }

  onSaveInterPretation() {
    this.generatedInterpretation = true;
    if (this.interpretationForm.controls['interpretation'].invalid) {
      return;
    }
    this.reportService
      .saveInterpretation(
        Number(atob(decodeURIComponent(customDecode(location.href.split('/')?.[6])))),
        addFullStop(this.interpretationForm.controls['interpretation'].value)
      )
      .subscribe((data: any) => {
        if (data.messageType == 0) {
          this.toaster.success(data.message);
        } else {
          this.toaster.error(data.error);
        }
      });
  }

  // Function to add opacity to an RGB value
  addOpacity(rgb: any, opacity: any) {
    return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
  }

  convertToMultiArr(genVertical?: boolean) {
    const data: any = [];
    this.componentItemsArray.forEach((ele: any, i: any) => {
      const chartValue = getRandomColorWithOpacity(this.opacity || 0.5);
      let addObj: any = [];
      const valuesArray = ele.impactValues.split(';');
      const percentArray = ele.percentage.split(';').map((x: any) => parseFloat(x).toFixed(2));
      addObj = {
        data: valuesArray,
        label: ele.name,
        stack: 'a',
        borderWidth: {
          top: genVertical ? 0 : 1.5, // Set the border width for the top side
          right: genVertical ? 1.5 : 0, // Set the border width for the right side
          bottom: 0, // Set the border width for the bottom side
          left: 0, // Set the border width for the left side
        },
        borderSkipped: false,
      };
      // !genVertical && (addObj['percent'] = percentArray);
      // genVertical && (addObj['stack']='a')
      if (ele.name != 'Total') {
        addObj['backgroundColor'] = chartValue[i].rgba;
        addObj['borderColor'] = chartValue[i].rgb;
        addObj['pointBackgroundColor'] = chartValue[i].rgb;
        addObj['pointBorderColor'] = chartValue[i].rgb;
        data.push(addObj);
      }
      // if (this.barChartOptions.scales.y.title) this.barChartOptions.scales.y.title.text = this.indicatorsName;
      // else {
      //   this.barChartOptions.scales.y.title = {};
      //   this.barChartOptions.scales.y.title['text'] = this.indicatorsName;
      // }
      this.barChartOptions.scales.y.title.text = this.indicatorsName;
      if (genVertical) {
        this.barChartOptions.indexAxis = 'y';
        this.barChartOptions.scaleShowVerticalLines = true;
      } else {
        this.barChartOptions.indexAxis = null;
        this.barChartOptions.scaleShowVerticalLines = false;
      }
      // this.barChartOptions = {
      //   ...this.barChartOptions,
      //   scales: {
      //     x: {
      //       ticks: {
      //         callback: genVertical ? this.verticalBarChartfunc : this.defaultBarChartfunc
      //       }
      //     },
      //     y: {
      //       ticks: {
      //         callback: genVertical ? this.defaultBarChartfunc : this.verticalBarChartfunc,
      //       },
      //     }
      //   }
      // }
    });
    return data;
  }

  GetSpiderChart() {
    const data: any = [];
    this.componentItemsArray.forEach((ele: any, i: any) => {
      let addObj: any = [];
      const chartValue = getRandomColorWithOpacity(this.opacity);
      const splitArray = ele.totals.split(';');
      const valuesArray = splitArray.map((data: any) => parseFloat(data).toFixed(2));
      this.chartImage = ele.indicatorImageName.split(';');
      addObj = {
        data: valuesArray,
        label: ele.scenarioname,
        backgroundColor: chartValue[i].rgba,
        borderColor: chartValue[i].rgb,
        borderWidth: '1.4',
        pointBackgroundColor: chartValue[i].rgba,
        pointBorderColor: chartValue[i].rgb,
      };
      data.push(addObj);
    });
    return data;
  }

  generateIndicators(data: any, scenarioData: any) {
    this.packagingComponentItems = data;
    const dynamicProperty = 'componentId';
    const groupedRecords = this.groupRecordsByProperty(data, dynamicProperty);

    // Access the arrays for each group
    this.pointersArray = Object.keys(groupedRecords).map(key => groupedRecords[key]);

    this.pointersArray = this.pointersArray.map((el: any) => ({
      el: this.setPointers(el, scenarioData),
      id: el[0]?.componentId,
    }));

    this.gaugeLegends = [...this.pointersArray[0]?.el];
    const [preferred1, preferred2, preferred3] = this.speedosImpactCategoryItems.filter(
      (x: any) => x.selected
    );
    const defaultCategory = this.speedosImpactCategoryItems[0];

    this.packagingComponent1 = preferred1?.id ?? defaultCategory.id;
    this.packagingComponent2 = preferred2?.id ?? defaultCategory.id;
    this.packagingComponent3 = preferred3?.id ?? defaultCategory.id;

    this.packagingComponentName1 = preferred1?.name ?? defaultCategory.name;
    this.packagingComponentName2 = preferred2?.name ?? defaultCategory.name;
    this.packagingComponentName3 = preferred3?.name ?? defaultCategory.name;

    this.pointers = this.prepareGaugeData([...this.pointersArray[preferred1?.id - 1 || 0].el]);
    this.pointers1 = this.prepareGaugeData([...this.pointersArray[preferred2?.id - 1 || 0].el]);
    this.pointers2 = this.prepareGaugeData([...this.pointersArray[preferred3?.id - 1 || 0].el]);
  }

  getMaxValue(dataArray: any[]): number {
    const maxDefaultValue = 100;
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      return maxDefaultValue;
    }
    const values = dataArray.map(item => {
      if (item && typeof item.value === 'number') {
        return item.value;
      }
      return maxDefaultValue;
    });
    const max = Math.max(...values);
    return Math.ceil(max);
  }

  setPointers(pointerArray: any, scenarioData: any) {
    pointerArray = this.getCurrentPointer(pointerArray);
    return pointerArray.map((element: any, index: any) => ({
      ...element,
      index: index,
      label: scenarioData[index]?.shortScenarioName || scenarioData[index]?.name,
      hideLegends: false,
    }));
  }

  prepareGaugeData(pointers: any[]): any[] {
    return pointers.map(pointer => ({
      ...pointer,
      value: pointer.value || 0,
      color: pointer.color || '#9747ff',
      label: pointer.label || '',
      formatedValue: pointer.formatedValue || `${pointer.value}%`,
    }));
  }

  getTopIndicatorName(data: any) {
    switch (data) {
      case 14:
        this.topIndicatorName = 'Contribution by life cycle stages';
        break;
      case 16:
        this.topIndicatorName = 'Contribution by packaging levels';
        break;
      case 18:
        this.topIndicatorName = 'Contribution by packaging components';
        break;
      case 17:
        this.topIndicatorName = 'Contribution by product waste';
        break;
      case 19:
        this.topIndicatorName = 'Contribution by ingredients';
        break;
      case 20:
        this.topIndicatorName = 'Contribution of transport';
        break;
      default:
        break;
    }
  }

  changePackagingComponent(value: any, indicatorNo: number) {
    this.pointersArray[value.id - 1].el.map((ele: any) => {
      if (
        this.gaugeLegends
          .filter((x: any) => x.hideLegends)
          .filter((y: any) => y.color == ele.color && y.label == ele.label).length
      ) {
        return (ele.hideLegends = this.gaugeLegends
          .filter((x: any) => x.hideLegends)
          .filter((y: any) => y.color == ele.color && y.label == ele.label)[0].hideLegends);
      } else {
        return (ele.hideLegends = false);
      }
    });
    this.gaugeLegends = [...this.pointersArray[value.id - 1].el];
    if (indicatorNo == 1) {
      this.pointers = this.pointers.length
        ? [...this.pointersArray[value.id - 1].el.filter((x: any) => !x.hideLegends)]
        : this.pointers;
      this.packagingComponent1 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentId;
      this.packagingComponentName1 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentName;
    } else if (indicatorNo == 2) {
      this.pointers1 = this.pointers1.length
        ? [...this.pointersArray[value.id - 1].el.filter((x: any) => !x.hideLegends)]
        : this.pointers1;
      this.packagingComponent2 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentId;
      this.packagingComponentName2 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentName;
    } else {
      this.pointers2 = this.pointers2.length
        ? [...this.pointersArray[value.id - 1].el.filter((x: any) => !x.hideLegends)]
        : this.pointers2;
      this.packagingComponent3 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentId;
      this.packagingComponentName3 = this.packagingComponentItems.find(
        (x: any) => x.componentId == value.id
      ).componentName;
    }
  }

  // Group the records based on the specified property
  groupRecordsByProperty(records: any[], property: string): any {
    const groupedRecords: any = {};
    records.forEach(record => {
      const value = record[property];
      if (groupedRecords[value]) {
        groupedRecords[value].push(record);
      } else {
        groupedRecords[value] = [record];
      }
    });
    return groupedRecords;
  }

  getCurrentPointer(array: any) {
    array.forEach((x: any, index: any) => {
      if (x.value > 25) {
        // x['color'] = '#FB3BFF',
        x['length'] = 1;
      } else if (x.value > 75) {
        //  x['color'] = '#FF9B14',
        x['length'] = 1;
      } else {
        // x['color'] = '#9747ff',
        x['length'] = 1;
      }
      x['color'] =
        index + 1 == 1
          ? 'rgba(151,71,255,1)'
          : index + 1 == 2
          ? 'rgba(251,59,255,1)'
          : index + 1 == 3
          ? 'rgba(255,46,52,1)'
          : index + 1 == 4
          ? 'rgba(255,151,20,1)'
          : index + 1 == 5
          ? 'rgba(20,232,5,1)'
          : 'rgba(5,232,250,1)';
    });
    return array;
  }

  hidePointer(pointer: any) {
    const hideLegends = !this.gaugeLegends.filter(
      (x: any) => x.color == pointer.color && x.label == pointer.label
    )[0].hideLegends;
    this.gaugeLegends.filter(
      (x: any) => x.color == pointer.color && x.label == pointer.label
    )[0].hideLegends = hideLegends;

    const index = this.pointers.findIndex(
      (x: any) => x.color == pointer.color && x.label == pointer.label
    );
    const index1 = this.pointers1.findIndex(
      (x: any) => x.color == pointer.color && x.label == pointer.label
    );
    const index2 = this.pointers2.findIndex(
      (x: any) => x.color == pointer.color && x.label == pointer.label
    );
    if (hideLegends) {
      this.pointers.splice(index, 1);
      this.pointers1.splice(index1, 1);
      this.pointers2.splice(index2, 1);
    } else {
      const pointer1 = this.pointersArray[this.packagingComponent1 - 1].el.find(
        (x: any) => x.color == pointer.color && x.label == pointer.label
      );
      const pointer2 = this.pointersArray[this.packagingComponent2 - 1].el.find(
        (x: any) => x.color == pointer.color && x.label == pointer.label
      );
      const pointer3 = this.pointersArray[this.packagingComponent3 - 1].el.find(
        (x: any) => x.color == pointer.color && x.label == pointer.label
      );

      if (pointer1) this.pointers.push(this.prepareGaugeData([pointer1])[0]);
      if (pointer2) this.pointers1.push(this.prepareGaugeData([pointer2])[0]);
      if (pointer3) this.pointers2.push(this.prepareGaugeData([pointer3])[0]);
    }

    this.pointers = [...this.pointers];
    this.pointers1 = [...this.pointers1];
    this.pointers2 = [...this.pointers2];
  }

  /**
   * Opens the GenerateChartReport version of this screen in a new tab.
   * Temporary verification aid — remove together with the `chart-at-glance-v2`
   * route once the new numbers are signed off.
   */
  openNewChartAtGlance() {
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    const tree = this.router.createUrlTree([
      `projects/projects-setting/${customEncode(btoa(encodedValue))}/chart-at-glance-v2`,
    ]);
    // The app routes with `useHash: true`, so the openable URL needs the `#`
    // prefix that `serializeUrl` alone does not add — without it the new tab
    // requests a server path and the app boots at the empty hash (dashboard).
    const url = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(tree));
    window.open(url, '_blank');
  }

  nextPage() {
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate([
      `projects/projects-setting/${customEncode(btoa(encodedValue))}/interpretation`,
    ]);
    this.sharedService.accessSideBarData(() => {});
    this.sharedService.scenarioNameFunc('Intrepretation');
  }

  onSelectWeight() {
    this.isWeightSelected = false;
  }
  onSelectNonWeight() {
    this.isWeightSelected = true;
  }

  defaultBarChartfunc = (value: any, index: any) => {
    const label = this.mbarChartLabels[index];
    const width = 18; // Adjust the width as needed
    const wrappedLabel = wrapLabel(label, width);
    return wrappedLabel;
  };

  verticalBarChartfunc = (value: any, index: any, values: any) => {
    const valueFormat =
      value.toString().includes('e') || value.toString().includes('E')
        ? value.toExponential(2)
        : yAxisformateValue(value);
    return valueFormat;
  };

  eolAction(event: any) {
    this.eolNavService.eolAction(
      event,
      event == 'fill-data-list' ? this.incorrectFilling : this.inValidScenarios, // change when incorrect add
      this.activatedRouteProjectId,
      scenario =>
        this.eolNavService.navigateToScenario(scenario, this.activatedRouteProjectId, event)
    );
  }
}
